module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAGZmZv///yH5BAAHAP8ALAAAAAAMAAwAAAIXhI+pGt37QIBTVuRiivrw61WdkYHLiRYAOw=="